import { core } from '@mockup/core.func';
import stepSlider from './func/globals/slider.step';

import '@mockup/func/globals/App.util';

const showOverloebWarning = function () {
    if ($('input[name=rbtnpensionsberegner1]').is(':checked')) {
        $('#uiDiv_Warning')
            .children()
            .each(function () {
                $(this).addClass('hide');
            });

        $('#uiDiv_Warning').removeClass('hide');
        var udb = $('input[name=rbtnpensionsberegner1]:checked').attr('id');
        // ekstraaldersforsikring, ekstrapension, livslangekstrapension
        if (udb == 'ekstraaldersforsikring') {
            $('#uiP_Note_Aldersforsikring').removeClass('hide');
        } else if (udb == 'ekstrapension') {
            $('#uiP_Note_Ekstrapension').removeClass('hide');
        } else if (udb == 'livslangekstrapension') {
            $('#uiP_Note_Livslang').removeClass('hide');
        }
    } else {
        resetWarning();
    }
};

const resetWarning = function () {
    $('#uiDiv_Warning').addClass('hide');
};

const tilpasSliderFoerSliderchange = function () {
    var api = $('#rsEkstra').data('plugin_rangeslider');
    var typed = $('#ipEkstra').val();

    if (typed.indexOf('.') >= 0) {
        typed = $('#ipEkstra')
            .val()
            .replace(/(\d+).(?=\d{3}(\D|$))/g, '$1'); // Hvis input IKKE er et int felt, kan tusindetalssepratorer forekomme (1.000)
    }

    typed = typed.replace(/,/g, '.'); // erstatter , med . (bliver fjernet igen ved math.floor())

    var min = api.min;
    var max = api.max;
    var parent = $('#ipEkstra').parent();

    if ($.isNumeric(typed) === false) {
        typed = min;
        parent.addClass('error');
        parent.next('.msg.error').show();
    } else {
        typed = Math.floor(typed);
        parent.removeClass('error');
        parent.next('.msg.error').hide();
    }

    api.setPosition(api.getPositionFromValue(typed));

    if (typed > max) {
        $('#ipEkstra').val(max);
        api.setPosition(api.getPositionFromValue(max));
        showOverloebWarning();
    } else if (typed < min) {
        $('#ipEkstra').val(min);
        api.setPosition(api.getPositionFromValue(min));
    } else if (typed >= min && typed <= max) {
        $('#ipEkstra').val(typed);
        api.setPosition(api.getPositionFromValue(typed));
    }
    var x = api.$element[0];
    return x;
};

const SliderChange = function (selector) {
    const element = selector.id; // rsCurrentAge, rsPensionYear
    let currentAge = $('#rsCurrentAge').val();
    const pensionYear = $('#rsPensionYear').val();

    currentAge++;
    if (currentAge > pensionYear) {
        // CurrentAge flyttes
        if (element == 'rsCurrentAge') {
            $('#ipPensionYear').val(currentAge);
            var api1 = $('#rsPensionYear').data('plugin_rangeslider');
            if (api1 != null) {
                api1.setPosition(api1.getPositionFromValue(currentAge));
            }
        } else if (element == 'rsPensionYear') {
            // PensionYear flyttes
            $('#ipCurrentAge').val(pensionYear - 1);
            var api2 = $('#rsCurrentAge').data('plugin_rangeslider');
            if (api2 != null) {
                var x = api2.getPositionFromValue(pensionYear - 1);
                api2.setPosition(x);
            }
        }
    }

};

const aldersopsparing = {
    init: function () {
        $('.lightbox-aldersopsparing').each(function () {
            var elm = $(this);
            $(this).fancybox(
                App.Util.lightbox.options(elm.data(), {
                    ajax: { type: 'post' },
                    padding: 20,
                    type: 'ajax',
                    width: 'auto',
                    title: false,
                    minHeight: 0,
                    afterShow: function (instance, current) {
                        $('.accordion .accordion-header > a').on('click', function () {
                            var self = $(this);
                            var parent = self.parents('.accordion');
                            $('.accordion').not(parent).removeClass('open');
                            $('.accordion').not(parent).find('.accordion-content').slideUp();
                            parent.toggleClass('open');
                            parent.find('.accordion-content').slideToggle();
                            return false;
                        });

                        $('#btnToggle').on('click', function () {
                            $('#articleToggle').slideToggle();
                            $(this).text(function (i, text) {
                                return text === '+ Vis oversigt' ? '- Skjul' : '+ Vis oversigt';
                            });
                        });
                    }
                })
            );
        });

        $('#btnNaesteStatus').removeClass('is-loading').prop('disabled', false);
        $('#btnNaesteStatus').on('click', function () {
            setTimeout(function () {
                $('#btnNaesteStatus').toggleClass('is-loading').prop('disabled', true);
            }, 1);
        });

        $('#btnNaesteTilpas').on('click', function (e) {
            if (!$('input:radio[name="ValgtOpsparing"]').is(':checked')) {
                $('#DivTilpasAldersopsparingValidator').removeClass('hide');
                e.preventDefault();
                return false;
            } else {
                $('#DivTilpasAldersopsparingValidator').addClass('hide');
                return true;
            }
        });

        $('input:radio[name="ValgtOpsparing"]').on('click', function () {
            $('#DivTilpasAldersopsparingValidator').addClass('hide');
        });
    }
};

const seniorfridage = {
    init() {
        stepSlider({
            selector: '.js-sf-stepslider',
            onInit: function () {
                var SFBFormSubmit = function () {
                    var $form = $(this);

                    $.ajax({
                        url: $form.attr('action'),
                        type: $form.attr('method'),
                        data: $form.serialize()
                    }).done(function (data) {
                        $('#resultSection').html(data);

                        $('.table > tbody tr').each(function () {
                            if ($(this).find('td:eq(1)').html() != $(this).find('td:eq(2)').html()) {
                                $(this).attr('style', 'font-weight:bold');
                            }
                        });

                        var $tip = $('.stepslider__tip');
                        var showSliderTip = $('#showSliderTip').val();
                        $tip.toggleClass('is-shown', showSliderTip > 0);
                    });

                    return false;
                };

                this.$form = $('form#sfbform');
                this.$form.on('submit', SFBFormSubmit);
            },
            onSlideEnd: this.onSlideEnd
        });
    },
    onSlideEnd(position, value) {
        $('.js-sf-stepslider').attr('name', value);
        if ($('#resultSection:not(:visible)')) {
            $('#resultSection').show(1000);
        }

        this.$form.trigger('submit');
    }
};

const kontaktOplysningerFraVirksomheder = {
    antiForgeryToken: '',
    init: function () {
        if ($('.js-kontaktoplysninger-fra-virksomheder').length) {
            $('.fancy-modal-trigger').fancybox({
                beforeShow: kontaktOplysningerFraVirksomheder.beforeShow,
                afterClose: kontaktOplysningerFraVirksomheder.afterClose
            });
            kontaktOplysningerFraVirksomheder.eventListener();
            kontaktOplysningerFraVirksomheder.antiForgeryToken = $(
                ".rykker-table-replace input[name='__RequestVerificationToken']"
            ).attr('value');
        }
    },
    error: function () {
        if (typeof window.ga === 'function') {
            window.ga('send', 'event', 'login', 'medlem', 'validerEmailDomaene_uventetfejl');
        }
    },
    eventListener: function () {
        $('.js-kontaktoplysninger-fra-virksomheder').on('click', '.pagedList a[href]', function (e) {
            $.ajax({ url: $(this).attr('href'), type: 'GET' }).done(function (data) {
                $('.rykker-table-replace').replaceWith(data);
            });

            return false;
        });

        var modalId = $('.js-kontaktoplysninger-fra-virksomheder').attr('data-modal-id');
        var modal = $('.js-kontaktoplysninger-fra-virksomheder').find('#' + modalId);
        var fields = kontaktOplysningerFraVirksomheder.getModalFields(modal);
        fields.email.on('focus', function () {
            visBekraeftEmailFelt(true);
        });
        fields.phone.on('blur', function () {
            kontaktOplysningerFraVirksomheder.validate(fields);
        });
        fields.email.on('blur', function () {
            if (!validateEmailLengthMax50(fields.email)) {
                setValidationError(fields.email, 'E-mail må maksimalt indeholde 50 karakterer');
            } else if (kontaktOplysningerFraVirksomheder.validate(fields)) {
                harAendretKontaktoplysninger = true;
                setValidationOk(email);
                validateEmailDomainName(email);
            }
        });

        fields.tin.on('blur', function () {
            kontaktOplysningerFraVirksomheder.validate(fields);
        });
    },
    validate: function (fields) {
        var valid = true;
        const emailPresent = fields.email.val().length && !fields.email.attr('disabled');
        const phonePresent = fields.phone.val().length;

        // Clear validation
        setValidationOk(fields.email);
        setValidationOk(fields.phone);

        if (emailPresent) {
            valid = validateEmail(fields.email) && valid;
            valid = validateMobile(fields.phone) && valid;
        } else {
            valid = validateMobileRequired(fields.phone) && valid;
        }

        const phoneFormatErrorTexts = fields.phone.siblings('.error').children('[data-validation-format="true"]');
        const phoneOrEmailRequiredErrorTexts = fields.phone
            .siblings('.error')
            .children('[data-validation-required-both="true"]');
        const phoneRequiredErrorTexts = fields.phone.siblings('.error').children('[data-validation-required="true"]');

        if (!phonePresent && !emailPresent) {
            phoneOrEmailRequiredErrorTexts.show();
            phoneFormatErrorTexts.hide();
            phoneRequiredErrorTexts.hide();
        } else {
            phoneOrEmailRequiredErrorTexts.hide();
            phoneRequiredErrorTexts.hide();
            phoneFormatErrorTexts.show();
        }

        if (fields.email.attr('disabled') && !phonePresent) {
            phoneOrEmailRequiredErrorTexts.hide();
            phoneRequiredErrorTexts.show();
            phoneFormatErrorTexts.hide();
        }

        if (fields.tin[0] && !fields.tin.attr('disabled')) {
            const tinRequiredErrorTexts = fields.tin.siblings('.error').children('[data-validation-required="true"]');
            const tinFormatErrorTexts = fields.tin.siblings('.error').children('[data-validation-format="true"]');

            if (!fields.tin.val().length) {
                // tinRequiredErrorTexts.show();
                tinFormatErrorTexts.hide();
            } else {
                tinRequiredErrorTexts.hide();
                tinFormatErrorTexts.show();
            }
            const validateTinFieldLength = (elm, min, max) => {
                const len = elm.value?.length();
                if (!len) {
                    return true;
                }

                return len > min && len < max;
            };

            const lengthValid = validateTinFieldLength(fields.tin, -1, 21);

            if (lengthValid === false) {
                setValidationError(fields.tin);
            } else {
                setValidationOk(fields.tin);
            }

            valid = lengthValid && valid;
        }

        return valid;
    },
    beforeShow: function () {
        var modal = this.content[0];
        var btn = this.element[0];

        if (!modal || !btn) {
            return;
        }

        const modalFields = kontaktOplysningerFraVirksomheder.getModalFields(this.content);
        this.content.find('.fancy-modal-close').on('click', () => $.fancybox.close());

        const saveBtn = this.content.find('.fancy-modal-save');
        saveBtn.on('click', () =>
            kontaktOplysningerFraVirksomheder.save(
                saveBtn,
                btn.getAttribute('data-postback-url'),
                modalFields,
                btn.getAttribute('data-cpr')
            )
        );
        saveBtn.addClass('btn-dark');

        const name = btn.getAttribute('data-name');
        const cpr = btn.getAttribute('data-cpr');
        const email = btn.getAttribute('data-email');
        const phone = btn.getAttribute('data-phone');
        const tinPresent = btn.getAttribute('data-tin-present');
        const tinRelavant = btn.getAttribute('data-tin-relavant');
        const hasDataText = btn.getAttribute('data-has-data-text');
        const notRelavantText = btn.getAttribute('data-not-relavant-text');

        modalFields.name.html(name);
        modalFields.cpr.html(cpr);

        if (btn.getAttribute('data-email-required')) {
            modalFields.email.val(email);
        } else {
            modalFields.email.val(hasDataText);
            modalFields.email.attr('disabled', true);
        }

        modalFields.phone.val(phone);
        modalFields.tin.attr('disabled', !(!tinPresent && tinRelavant));

        if (!tinRelavant) {
            modalFields.tin.val(notRelavantText);
        } else if (tinPresent) {
            modalFields.tin.val(hasDataText);
        }
    },
    afterClose: function () {
        var modalFields = kontaktOplysningerFraVirksomheder.getModalFields(this.content);
        this.content.find('.fancy-modal-close').unbind();
        this.content.find('.fancy-modal-save').unbind();
        modalFields.email.val('');
        modalFields.email.attr('disabled', false);
        setValidationOk(modalFields.email);
        setValidationOk(modalFields.phone);
        modalFields.tin.val('');
        modalFields.tin.attr('disabled', false);
        setValidationOk(modalFields.tin);
        modalFields.name.val('');
        modalFields.cpr.val('');
    },
    save: function (btn, postBackUrl, fields, cpr) {
        if (!kontaktOplysningerFraVirksomheder.validate(fields)) return false;

        var model = {
            __RequestVerificationToken: kontaktOplysningerFraVirksomheder.antiForgeryToken,
            cpr: cpr,
            // eslint-disable-next-line no-extra-boolean-cast
            email: !!fields.email.attr('disabled') ? null : fields.email.val(),
            phone: fields.phone.val(),
            // eslint-disable-next-line no-extra-boolean-cast
            tin: !!fields.tin.attr('disabled') ? null : fields.tin.val()
        };

        btn.toggleClass('btn-dark').toggleClass('is-loading').prop('disabled', true);

        $.post(postBackUrl, model)
            .done((data) => {
                btn.toggleClass('is-loading').toggleClass('btn-dark').prop('disabled', false);

                if (data.success) {
                    location.reload();
                    return;
                }

                alertify.alert('<h3><center>' + data.reason + '</center></h3>');
            })
            .fail(() => {
                const errorLabel = btn.attr('data-general-submit-error');
                alertify.alert('<h3><center>' + errorLabel + '</center></h3>');
                btn.toggleClass('is-loading').toggleClass('btn-dark').prop('disabled', false);
            });
    },
    getModalFields: function (modal) {
        return {
            name: modal.find('#name'),
            cpr: modal.find('#cpr'),
            email: modal.find('#email'),
            bekraeftEmail: modal.find('#bekraeftEmail'),
            phone: modal.find('#phone'),
            tin: modal.find('#tin')
        };
    }
};

const indbertningStart = {
    init() {
        if (!$('#flow-indberetning-ny-kladde').length) return;

        $('input[name="udgangspunkt"]').on('change', function () {
            const $this = $(this);

            $('#option-udgangspunkt-seneste').toggle($this.attr('id') === 'radio-udgangspunkt-senest');
            $('#option-udgangspunkt-file').toggle($this.attr('id') === 'radio-udgangspunkt-file');
        });

        $('#select-peride').on('change', function () {
            $('#selected-udgangspunkt-seneste').toggle($(this).val() === 'valgfri');
        });

        var minDate = $('.range-picker').data('min-date');
        var maxDate = $('.range-picker').data('max-date');

        $('.range-picker')
            .on('click', function () {
                $(this).find('.range-picker-overlay').show();
            })
            .datepickerrange({
                startDate: minDate,
                endDate: maxDate,
                endPick: function (selected) {
                    $('.range-picker')
                        .find('.input.input-calendar')
                        .val(selected.fromDateText + ' - ' + selected.toDateText);
                }
            });

        $(window)
            .on('click', function (e) {
                if (!$(e.target).hasClass('range-picker') && !$(e.target).parents('.range-picker').length) {
                    checkDatePicker();
                }
            })
            .on('keydown', function (e) {
                if (e.keyCode === 9 && $(e.target).hasClass('to')) {
                    checkDatePicker();
                }
            });

        function checkDatePicker() {
            setTimeout(function () {
                $('.range-picker-overlay').each(function () {
                    if ($(this).css('display') === 'block') {
                        var parent = $(this).parents('.range-picker');
                        if (parent.find('.to').val() !== '' && parent.find('.from').val() !== '') {
                            $(this).hide();
                        } else {
                            parent.find('.range-error').removeClass('hide');
                            parent.find('.range-picker input:first').focus();
                        }
                    }
                });
            });
        }
    }
};

const voresSide = {
    init() {
        $('[data-read-more-id]').on('click', function () {
            $('#' + $(this).data('readMoreId')).toggleClass('show');
            $(this).toggleClass('show');
        });

        if ($('#important-modal').length) {
            $.fancybox.open({
                href: '#important-modal',
                type: 'inline'
            });

            $('.important-modal-close').on('click', function () {
                $.fancybox.close();
            });
        }
    }
};

const nyIndberetning = {
    init: function () {
        var form = $('#ny-indberetning');
        if (form.length > 0) form.submit(nyIndberetning.submitForm);
    },
    submitForm: function () {
        var checked = $('input[name=udgangspunkt]:checked').val();
        if (checked === 'File') {
            const dropzoneInstance = 'VIRK_NYINDBERETNING';
            var arr = window.IPFileUploader[dropzoneInstance];
            var verified = arr.getVerifiedFiles();
            var notVerified = arr.getNotVerifiedFiles();
            if (notVerified.length > 0 || verified.length === 0) {
                return false;
            }
        }
        var $form = $(this);
        if (!nyIndberetning.validate($form)) {
            return false;
        }

        function handleError(errorType, debugmessage, errorline, errorfield) {
            const badFormat = $form.find('#file-error-bad-format');
            const badData = $form.find('#file-error-bad-data');
            const unparsableFormat = $form.find('#file-error-unparsable-file');
            const generalError = $form.find('#file-error-general-error');
            badFormat.hide();
            badData.hide();
            unparsableFormat.hide();
            generalError.hide();

            switch (errorType) {
                case 'badFormat':
                    badFormat.show();
                    break;
                case 'unparsableFile':
                    unparsableFormat.show();
                    if (debugmessage != undefined) {
                        unparsableFormat.append('<br/><span>' + debugmessage + '</span>');
                    }
                    if (errorline > 0) {
                        unparsableFormat.append('<br/><span>I linie: ' + errorline + '.</span>');
                    }
                    break;
                case 'badData':
                    badData.show();
                    if (debugmessage != undefined) {
                        badData.append('<br/><span>' + debugmessage + '</span>');
                    }
                    if (errorline > 0) {
                        badData.append('<br/><span>I linie: ' + errorline + '</span>');
                    }
                    if (errorfield > 0) {
                        badData.append('<br/><span>, felt: ' + errorfield + '</span>');
                    }
                    break;
                default:
                    generalError.show();
                    if (debugmessage != undefined) {
                        generalError.append('<br/><span>' + debugmessage + '</span>');
                    }
                    break;
            }
        }

        const button = $form.find('button[type="submit"]');
        button.addClass('is-loading');

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize()
        })
            .done(function (data) {
                button.removeClass('is-loading');

                if (!data.success) {
                    handleError(data.fileError, data.debugMessage, data.errorLine, data.errorField);
                    return;
                }

                if (data.redirectUrl) {
                    location.replace(data.redirectUrl);
                    return;
                }
            })
            .fail(() => {
                button.removeClass('is-loading');
                handleError();
            });
        return false;
    },
    validate: function (form) {
        var valid = validateRequiredRadioBtn('udgangspunkt');

        if (form.find('input[name="udgangspunkt"][value="File"]').is(':checked')) {
            valid = validateRequiredRadioBtn('filformat') && valid;
            valid = validateRequiredRadioBtn('filtype') && valid;
        }

        return valid;
    }
};

// --------------------------- Exposed to App.Util
const pensionsberegner = {
    // prognose feltet skal skjules da der ikke er en prognose at vise
    init: function () {
        $('.collectionbox').hide();
        $('.loadingdiv').hide();
        // initialisering af sliders
        this.setupAlderRangeSlider('#rsCurrentAge', '#ipCurrentAge');
        this.setupAlderRangeSlider('#rsPensionYear', '#ipPensionYear');
        this.setupRangeSlider('#rsEkstra', 0, 28100, 200, 0, '#ipEkstra');

        $('#ipCurrentAge').on('change', function (e) {
            // remove everying that is not at digit
            var formattedValue = e.target.value.replace(/\D/g, '');
            // update the rangeslider value
            $('#rsCurrentAge').val(formattedValue).change();
        });

        $('input[name^=rbtnpensionsberegner]').on('click', () => {
            resetWarning(); // Defineret på cshtml -
            this.setupRanges();

        });
        $('#rsEkstra-btn').on('click', () => {
            $('#rsEkstra-btn').prop('disabled', true);
            this.beregnEkstraPension();
        });
    },
    calculate: function () {
        var pensionsType = $('input[name=rbtnpensionsberegner1]:checked').attr('id');
        var indbetalingsMaade = $('input[name=rbtnpensionsberegner2]:checked').attr('id');
        var indbetaling = $('#ipEkstra').val();
        var alder = $('#ipCurrentAge').val();
        var pensionsAlder = $('#ipPensionYear').val();
        // Function must be on cshtml view - because of ajax call

        doPrognose(alder, pensionsAlder, pensionsType, indbetalingsMaade, indbetaling);
        // annimation
        var speed = 1000;
        $('.collectionbox').slideUp(speed, function () {
            $('.loadingdiv').slideDown(speed);
        });
    },
    calculateDone: function () {
        // When result ready:
        var speed = 1000;
        $('.loadingdiv').slideUp(speed, function () {
            $('.collectionbox').slideDown(speed);
        });
    },
    isReadyToCalculate: function () {
        // er alt udfyldt rigtigt?
        var udbetalingAfPension = $('input[name=rbtnpensionsberegner1]').is(':checked');
        var indbetaling = $('#ipEkstra').val() != 0;
        return udbetalingAfPension && indbetaling;
    },
    // eslint-disable-next-line max-params
    setupRangeSlider: function (selector, min, max, step, value, inputSelector) {
        $(selector)
            .rangeslider('destroy')
            .attr({ min: min, max: max, step: step })
            .val(value)
            .rangeslider({
                polyfill: false,
                onSlide: function (left, value) {
                    $(inputSelector).val(value);
                },
                onSlideEnd: function (selector, value) {
                    // skjul evt. fejlbesked - finder sliderens input's parent(div)
                    const inpVal = this.$element.parents('.fu').find('.sliderOut').parent();
                    inpVal.removeClass('error');
                    inpVal.next('.msg.error').hide();

                    resetWarning(); // Defineret på cshtml -

                    $(inputSelector).val(value);

                    const currentAmount = $('#rsEkstra').val();

                    if (currentAmount >= max) {
                        showOverloebWarning();
                    } else {
                        resetWarning();
                    }

                }
            })
            .change();
    },
    setupAlderRangeSlider: function (selector, inputSelector) {
        $(selector)
            .rangeslider('destroy')
            .rangeslider({
                polyfill: false,
                onSlide: function (left, value) {
                    $(inputSelector).val(value);
                }
            })
            .change();

        $(inputSelector).on('change', function (e) {
            // remove everying that is not at digit
            var formattedValue = e.target.value.replace(/\D/g, '');
            // update the rangeslider value
            $(selector).val(formattedValue).change();
        });

        $(selector).on('change', function (e) {
            const value = e.target.value;
            const element = e.target.id; // rsCurrentAge, rsPensionYear
            let currentAge = $('#rsCurrentAge').val();
            const pensionYear = $('#rsPensionYear').val();
            $(inputSelector).val(value);

            currentAge++;
            if (currentAge > pensionYear) {
                // CurrentAge flyttes
                if (element == 'rsCurrentAge') {
                    $('#ipPensionYear').val(currentAge);
                    const api1 = $('#rsPensionYear').data('plugin_rangeslider');
                    if (api1 != null) {
                        api1.setPosition(api1.getPositionFromValue(currentAge));
                    }
                } else if (element == 'rsPensionYear') {
                    // PensionYear flyttes
                    $('#ipCurrentAge').val(pensionYear);
                    const api2 = $('#rsCurrentAge').data('plugin_rangeslider');
                    if (api2 != null) {
                        const x = api2.getPositionFromValue(pensionYear - 1);
                        api2.setPosition(x);
                    }
                }
            }
            // skjul evt. fejlbesked - finder sliderens input's parent(div)
            const inpVal = $(e.target).parents('.fu').find('.sliderOut').parent();
            inpVal.removeClass('error');
            inpVal.next('.msg.error').hide();

        });

    },
    loadSliderValues: function (spanSelector) {
        var values = $(spanSelector).html().split(',');
        var min = parseInt(values[0], 10);
        var max = parseInt(values[1], 10);
        var step = parseInt(values[2], 10);

        pensionsberegner.setupRangeSlider('#rsEkstra', min, max, step, 0, '#ipEkstra');
    },
    setupRanges: function () {
        var udbetalingAfPension = $('input[name=rbtnpensionsberegner1]').is(':checked');
        var ekstraPension = $('input[name=rbtnpensionsberegner2]').is(':checked');

        // er udbetaling ikke valgt bruges første valg (aldersopsparing) som default
        if (udbetalingAfPension == false && ekstraPension == true) {
            pensionsberegner.loadSliderValues('#uiSp_AlderFast');
        }
        if (udbetalingAfPension && ekstraPension) {
            var udbetalingAfPensionSelected = $('input[name=rbtnpensionsberegner1]:checked').attr('id');
            var ekstraPensionSelected = $('input[name=rbtnpensionsberegner2]:checked').attr('id');

            if (
                udbetalingAfPensionSelected == 'ekstraaldersforsikring' &&
                ekstraPensionSelected == 'fastmaanedligtbeloeb'
            ) {
                pensionsberegner.loadSliderValues('#uiSp_AlderFast');
            } else if (
                udbetalingAfPensionSelected == 'ekstraaldersforsikring' &&
                ekstraPensionSelected == 'engangsbeloeb'
            ) {
                pensionsberegner.loadSliderValues('#uiSp_AlderEngangs');
            } else if (
                udbetalingAfPensionSelected == 'ekstrapension' &&
                ekstraPensionSelected == 'fastmaanedligtbeloeb'
            ) {
                pensionsberegner.loadSliderValues('#uiSp_EPFast');
            } else if (udbetalingAfPensionSelected == 'ekstrapension' && ekstraPensionSelected == 'engangsbeloeb') {
                pensionsberegner.loadSliderValues('#uiSp_EPEngangs');
            } else if (
                udbetalingAfPensionSelected == 'livslangekstrapension' &&
                ekstraPensionSelected == 'fastmaanedligtbeloeb'
            ) {
                pensionsberegner.loadSliderValues('#uiSp_LivslangFast');
            } else if (
                udbetalingAfPensionSelected == 'livslangekstrapension' &&
                ekstraPensionSelected == 'engangsbeloeb'
            ) {
                pensionsberegner.loadSliderValues('#uiSp_LivslangEngangs');
            }
        }
    },
    beregnEkstraPension: function() {
        if (this.isReadyToCalculate()) {
            this.calculate();
        } else {
            $('#rsEkstra-btn').prop('disabled', false);
        }
    }
};
// TODO: isolate module
App.Util.pensionsberegner = pensionsberegner;

App.Util.common ??= {};
App.Util.common.showOverloebWarning = showOverloebWarning;
App.Util.common.tilpasSliderFoerSliderchange = tilpasSliderFoerSliderchange;
App.Util.common.SliderChange = SliderChange;


const afkastoginvesteringer = {
    init: function () {
        $('.VisSkjulAfkastPrMaaned').on('click', function (event) {
            event.preventDefault();

            if ($('.VisSkjulAfkastPrMaaned').text().indexOf('Se afkast pr. måned') >= 0) {
                $('.VisSkjulAfkastPrMaaned').text('Skjul afkast pr. måned');
                $('.afkast').slideDown();
            } else {
                $('.VisSkjulAfkastPrMaaned').text('Se afkast pr. måned');
                $('.afkast').slideUp();
            }
        });
    }
};

// TODO: isolate module
App.afkastoginvesteringer = afkastoginvesteringer;

const livstruendesygdomme = {
    helper: {
        toggleErrorClass(elems, bool) {
            elems.each(function () {
                $(this).parents('.fu').find('.msg').toggleClass('error', bool);
                $(this).parents('.fu').toggleClass('error', bool);
            });
        },
        setButtonsLoading() {
            $('#guide-next-button').addClass('is-loading');
            $('#guide-prev-button').addClass('is-loading');
        },
        removeButtonsLoading() {
            $('#guide-next-button').removeClass('is-loading');
            $('#guide-prev-button').removeClass('is-loading');
        }
    },
    vaelgUdbetaling(url, step, callback) {
        const _ = this;
        _.helper.setButtonsLoading();

        const ths = $('#lts-step1-form');
        const formIsValid = () => {
            // Validate the checkbox choice(s)
            const pensionCheckboxes = $('#checkbox-for-livtrunedesygedom');
            const hasUserChosenPensions = !(pensionCheckboxes.find('input:checked').length === 0) || false;
            _.helper.toggleErrorClass(pensionCheckboxes.find('input'), !hasUserChosenPensions);

            // Validate the radio button choice
            const blanketSource = $('input[name=BlanketSource]');
            const hasUserChosenABlanketType = blanketSource.is(':checked') || false;
            _.helper.toggleErrorClass(blanketSource, !hasUserChosenABlanketType);

            // Validate file upload
            const blanketUpload = $('#blanket-for-livtrunedesygedom');
            const dropzoneInstance = 'LIVSTRUENDESYGDOM_VALGAFUDBETALING';
            var arr = window.IPFileUploader[dropzoneInstance];
            var verified = arr.getVerifiedFiles();
            var notVerified = arr.getNotVerifiedFiles();
            var hasUserVerified = true;
            if (notVerified.length > 0 || verified.length === 0) {
                hasUserVerified = false;
            }
            _.helper.toggleErrorClass(blanketUpload.find('input'), !hasUserVerified);

            // Validate if the user has accepted terms and conditions
            const termsAndConditionsCheckbox = $('#TermsAndConditionsInput');
            const hasUserAcceptedTermsAndConditions = termsAndConditionsCheckbox.is(':checked') || false;
            _.helper.toggleErrorClass(termsAndConditionsCheckbox, !hasUserAcceptedTermsAndConditions);

            return (
                hasUserChosenPensions &&
                hasUserChosenABlanketType &&
                hasUserVerified &&
                hasUserAcceptedTermsAndConditions
            );
        };

        if (!formIsValid()) {
            _.helper.removeButtonsLoading();
            return false;
        }

        const data = ths.serialize();

        $.ajax({
            url: url,
            data: data,
            method: 'POST'
        })
            .done(function (response, request) {
                if (!response.Success) {
                    _.helper.setButtonsLoading();
                    $('#errorOverlay').show();
                    $('#errorBackendMessage').text(response.Message);
                    return;
                }

                callback(step, true, response, '');
            })
            .fail(function (response, request) {
                _.helper.removeButtonsLoading();
                callback(step, false, response);
            });
    },
    godkend(url, step, callback) {
        const _ = this;
        _.helper.setButtonsLoading();

        let godkendCheck = false;
        if (step != 1) {
            godkendCheck = false;
        } else {
            godkendCheck = true;
        }

        const form = $('<form><input type="hidden" name="godkendCheck" value="' + godkendCheck + '"></form>');
        const data = form.serialize();

        $.ajax({
            url: url,
            data: data,
            method: 'POST'
        })
            .done(function (response, request) {
                if (!response.Success) {
                    _.helper.removeButtonsLoading();

                    alertify.alert('<h3>Der er sket en fejl</h3><p>' + response.Message + '</p>');

                    return;
                }

                callback(step, true, response);
            })
            .fail(function (response, request) {
                _.helper.removeButtonsLoading();
                callback(step, false, response);
            });
    }
};

// TODO: isolate module
App.livstruendesygdomme = livstruendesygdomme;

const bankoplysninger2018 = {
    helper: {
        toggleErrorClass(elems, bool) {
            elems.each(function () {
                $(this).parents('.fu').find('.msg').toggleClass('error', bool);
                $(this).parents('.fu').toggleClass('error', bool);
            });
        }
    },
    validateBankoplysningerAndSaveToSession(url, step, callback, formName) {
        const _ = this;
        const ths = $(formName);
        const formIsValid = () => {
            // Validate the radio button choice - use has to choose something
            const kontoValg = $('input[name=Kontovalg]');
            const hasUserChosenABankOption = kontoValg.is(':checked') || false;
            _.helper.toggleErrorClass(kontoValg, !hasUserChosenABankOption);

            // Validate file upload - simply proceed of NemKonto is chosen.
            let hasUserUploadedBankoplysninger = true;

            if (!$('#nemKonto').is(':checked')) {
                const dropzoneInstance = 'BANKOPLYSNINGER';
                var arr = window.IPFileUploader[dropzoneInstance];
                var verified = arr.getVerifiedFiles();
                var notVerified = arr.getNotVerifiedFiles();
                if (notVerified.length > 0 || verified.length === 0) {
                    hasUserUploadedBankoplysninger = false;
                    const bankoplysningerUpload = $('#collapseOne');
                    _.helper.toggleErrorClass(bankoplysningerUpload, !hasUserUploadedBankoplysninger);
                } else {
                    hasUserUploadedBankoplysninger = true;
                }
            }
            return hasUserChosenABankOption && hasUserUploadedBankoplysninger;
        };

        if (step == -1) {
            callback(step, true, '', 'Back');
            return;
        }

        if (!formIsValid()) {
            callback(step, false, 'Form ikke udfyldt', 'Form ikke udfyldt');
            return false;
        }

        const data = ths.serialize();

        $.ajax({
            url: url,
            data: data,
            method: 'POST'
        })
            .done(function (response, request) {
                if (!response.Success) {
                    $('#errorBackendMessage').text(response.Message);
                    return;
                }

                callback(step, true, response, 'validateBankoplysningerAndSaveToSession ok');
            })
            .fail(function (response, request) {
                event.preventDefault();
                callback(step, false, response, 'Kunne ikke gemme oplysninger');
            });
    }
};

// TODO: isolate module
App.bankoplysninger2018 = bankoplysninger2018;

document.addEventListener('DOMContentLoaded', () => {
    core.init();

    if (document.querySelector('.js-min-side')) {
        import('@mockup/func/min-side/index').then((module) => new module.default());
    }

    if (document.querySelector('.js-baeredygtigt-afkast')) {
        import('@mockup/func/baeredygtigt-afkast/index').then(
            (module) => new module.default('.js-baeredygtigt-afkast')
        );
    }
    if (document.querySelector('[id^=ks-]')) import('@mockup/func/ks/index').then((module) => new module.default());
    if (document.querySelector('[id^=hy-]')) import('@mockup/func/hy/index').then((module) => new module.default());
    if (document.querySelector('[id^=senior-analyse-]')) {
        import('@mockup/func/seniorAnalyse/index').then((module) => new module.default());
    }
    if (document.querySelector('[id^=fritvalg-]')) {
        import('@mockup/func/fritvalg/index').then((module) => new module.default());
    }
    if (document.querySelector('.js-rykker')) {
        import('@mockup/func/rykker/index').then((module) => new module.default());
    }
    if (document.querySelector('.js-pensionsplan')) {
        import('@mockup/func/pensionsplan/index').then((module) => new module.default());
    }
    if (document.querySelector('.js-udbetaling-efterladte')) {
        import('@mockup/func/udbetaling-efterladte/index').then((module) => new module.default());
    }

    if (document.querySelector('.js-pensionstjek')) {
        import('@mockup/func/pensionstjek/index').then((module) => new module.default());
    }

    if (document.querySelector('.js-ekstra-indbetaling')) {
        import('@mockup/func/ekstra-indbetaling/index').then((module) => new module.default());
    }

    if (document.querySelector('.js-employer-branding')) {
        import('@mockup/func/employer-branding/index').then((module) => new module.default());
    }

    if (document.querySelector('.js-overfoer-pension')) {
        import('@mockup/func/overfoerPension/index').then((module) => new module.default());
    }

    aldersopsparing.init();
    seniorfridage.init();
    kontaktOplysningerFraVirksomheder.init();
    indbertningStart.init();
    voresSide.init();
    nyIndberetning.init();
    pensionsberegner.init();
});
